import { ToastManagerStore } from "@core/presentacion/component/feedback/toast-manager/toast-manager.store";
import { EmployeeRepository } from "@entity/data/repositories/employee.repository";
import { inject, injectable } from "inversify";

@injectable()
export class DeleteEmployeeUseCase {
    constructor(
        @inject(EmployeeRepository)
        private readonly employeeRepository: EmployeeRepository,
    ) {}

    async execute(employeeId: number): Promise<boolean> {
        const result = await this.employeeRepository.delete(employeeId);

        if (result.isLeft()) {
            ToastManagerStore.error(result.getLeftOrThrow().message);
            return false;
        }

        return true;
    }
}
